export const fileUploadState = {
    isUploadedToS3: false
};